
import { parseProductFromShopify } from '~/helpers/shopify/product'
import ProductTester from '~/helpers/shopify/tests'
import Carousel from '~/components/carousel/carousel'
import ProductCard from '~/components/product-card/ProductCard'
export default {
  components: {
    Carousel,
    ProductCard,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      products: [],
    }
  },
  mounted() {
    try {
      // Determine if we use the list of products ids and color or collection_handle
      // Search by ids/color_code
      if (this.blok.products && this.blok.products.length > 0)
        this.getProductsByIds()
      // Search by collection_handle
      else if (this.blok.collection_handle) this.getProductsByCollectionHandle()
      // Empty
      else return
    } catch (e) {
      this.$sentryException(e, {
        source: 'component-static-carousel-products',
        component: 'Static Carousel Products',
        level: 'danger',
        extra: 'failed to load static carousel products',
      })
    }
  },
  methods: {
    async getProductsByIds() {
      const parsedIds = this.parseIds(this.blok.products)
      const ids = this.getProductsId(parsedIds)
      const { data } = await this.$shopify.product.retrieveProducts(ids)
      if (data.errors) {
        throw new Error(JSON.stringify(data.errors))
      } else if (data.data.nodes && data.data.nodes.length > 0) {
        data.data.nodes.forEach((product, index) => {
          const test = new ProductTester(
            product,
            parsedIds[index].color,
            this.$i18n.locale
          )
          if (
            product &&
            test.productExist() &&
            test.colorExist() &&
            test.metafieldsExist() &&
            test.metafieldsLangExist() &&
            test.metafieldsColorExist()
          ) {
            const parsedProduct = parseProductFromShopify(
              product,
              this.$i18n.locale,
              parsedIds[index].color
            ).result
            // OVERWRIGHT IMAGE
            if (parsedIds[index].image) {
              parsedProduct.medias[0].src = parsedIds[index].image
            }
            this.products.push({
              data: parsedProduct,
              additionalText: parsedIds[index].additionalText
                ? parsedIds[index].additionalText.content
                : null,
            })
          }
        })
      }
    },
    async getProductsByCollectionHandle() {
      try {
        const url = `https://api.searchspring.net/api/search/search.json?siteId=${this.getSiteIdSS()}&resultsFormat=native&format=json&bgfilter.collection_handle=${
          this.blok.collection_handle
        }&resultsPerPage=10&page=1`
        const { data } = await this.$axios.get(url)
        if (data?.results?.length > 0) {
          const { resultProducts } =
            this.$searchspring.parseProducts.parse(data)

          resultProducts.forEach((product) => {
            this.products.push({
              data: product,
              additionalText: null,
            })
          })
        }
      } catch (e) {
        this.$sentryException(e, {
          source: 'Homepage - Carrousel Products',
          level: 'warning',
          extra: `Error : ${e}`,
        })
      }
    },
    parseIds(products) {
      if (products.length === 0) return null
      const ret = []
      products.forEach((product) => {
        ret.push({
          id: btoa(`gid://shopify/Product/${product.product_id}`),
          color: product.color_code,
          image:
            product.overwrite_image && product.overwrite_image.filename
              ? product.overwrite_image.filename
              : null,
          additionalText: product.additional_text || null,
        })
      })
      return ret
    },
    getProductsId(ids) {
      if (ids.length === 0) return null
      const ret = []
      ids.forEach(({ id }) => {
        ret.push(id)
      })
      return ret
    },
    getSiteIdSS() {
      if (this.$i18n.locale === 'en-ca')
        return this.$config.SEARCHSPRING_SITE_IDS.EN_CA
      if (this.$i18n.locale === 'fr-ca')
        return this.$config.SEARCHSPRING_SITE_IDS.FR_CA
      if (this.$i18n.locale === 'en-eu')
        return this.$config.SEARCHSPRING_SITE_IDS.EN_EU
      if (this.$i18n.locale === 'fr-eu')
        return this.$config.SEARCHSPRING_SITE_IDS.FR_EU
      return this.$config.SEARCHSPRING_SITE_IDS.EN_US
    },
    async parseResults(data) {
      this.products = await this.$searchspring.parseProducts.parse(data)
        ?.resultProducts
    },
  },
}
